import "./footer.css";
import logo from "../images/logo_footer.svg";
import tg from "../images/footer_tg.svg";
import insta from "../images/footer_insta.svg";
import tel from "../images/tel.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="footer">
      <div className="footer_link_content">
        <div data-aos="zoom-in" data-aos-anchor-placement="top-bottom">
          <ul className="link_box">
            <li>
              <a href="/#asosiy">{t("FOOTER.MAIN")}</a>
              <span></span>
            </li>
            <li>
              <a href="/#imkoniyat">{t("FOOTER.CHANCES")}</a>
              <span></span>
            </li>
            <li>
              <a href="/#product">{t("FOOTER.PRODUCT")}</a>
              <span></span>
            </li>
            <li>
              <a href="/#about">{t("FOOTER.ABOUTUS")}</a>
              <span></span>
            </li>
            <li>
              <a href="/#galery">{t("FOOTER.GALLERY")}</a>
              <span></span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer_social_link">
        <div data-aos="zoom-in" data-aos-anchor-placement="top-bottom">
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
        </div>

        <div className="social_box">
          <div data-aos="zoom-in" data-aos-anchor-placement="top-bottom">
            <div className="my_social_content">
              <a
                href="https://t.me/yuksalish_socks"
                target="_blank"
                className="social"
              >
                <img src={tg} alt="tg" />
                {t("FOOTER.TG")}
              </a>
              <span className="my_underline"></span>
            </div>
          </div>

          <div data-aos="zoom-in" data-aos-anchor-placement="top-bottom">
            <div className="my_social_content">
              <a
                href="https://www.instagram.com/yuksalish_socks/"
                className="social"
                target="_blank"
              >
                <img src={insta} alt="insta" />
                {t("FOOTER.INSTA")}
              </a>
              <span className="my_underline"></span>
            </div>
          </div>

          <div data-aos="zoom-in" data-aos-anchor-placement="top-bottom">
            <div className="my_social_content">
              <a href="tel:+998992292020" className="social">
                <img src={tel} alt="facebook" />
                {t("FOOTER.WHATSUP")}
              </a>
              <span className="my_underline"></span>
            </div>
          </div>
        </div>
      </div>

      <div data-aos="zoom-in" data-aos-anchor-placement="top-bottom">
        <div className="footer_text">
          <p>{t("FOOTER.TEXT")}</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
